require('./boolean.html');
require('./button.html');
require('./checkbox.html');
require('./custom_buttons.html');
require('./date.html');
require('./date_einstellungen.html');
require('./default_field.html');
require('./render_options.html');
require('./display_conditions.html');
require('./download.html');
require('./dropdown_multiple_select.html');
require('./dropdown_single_select.html');
require('./dropdown_single_select_ajax.html');
require('./dropdown_single_select_einstellungen.html');
require('./euro_betrag.html');
require('./euro_betrag_einstellungen.html');
require('./fieldgroup.html');
require('./file.html');
require('./file_einstellungen.html');
require('./form.html');
require('./format.html');
require('./h1.html');
require('./h2.html');
require('./hintbox.html');
require('./image.html');
require('./kfz_kennzeichen.html');
require('./media_accordion.html');
require('./media_accordion_element.html');
require('./multiple_file.html');
require('./placeholder.html');
require('./possible_values.html');
require('./radio_buttons.html');
require('./section.html');
require('./single_checkbox.html');
require('./string.html');
require('./string_ajax_autocomplete.html');
require('./submitted_with_npa_info.html');
require('./text.html');
require('./textarea.html');
require('./time.html');
require('./time_einstellungen.html');
require('./two_list_select.html');
require('./validation_rules.html');
require('./video.html');
